import { Component, OnInit } from "@angular/core";
import { RegisterService } from "../register.service";
import { ActivatedRoute } from "@angular/router";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { BreadcrumbService } from "../../../shared/services/breadcrumb.service";
import { CommonModule } from "@angular/common";
import { FeatherIconsComponent } from "../../../shared/components/feather-icons/feather-icons.component";
import { RenderSafeHtmlService } from "../../../shared/services/renderSafeHtml.service";
import { ToastrService } from "ngx-toastr";
import { GoogleTagManagerService } from "../../../shared/services/googletagmananer.service";

@Component({
  selector: "app-qr-code-viewer",
  standalone: true,
  imports: [CommonModule, TranslateModule, FeatherIconsComponent],
  templateUrl: "./qr-code-viewer.component.html",
  styleUrl: "./qr-code-viewer.component.scss",
})
export class QrCodeViewerComponent implements OnInit {
  token = "";
  tokenParticipant = "";
  anyErrors = false;
  responseType: number;

  mainObj: any;

  eventName: string;
  eventDescription: string;
  eventDates: any[] = [];
  eventAddress: string;
  eventType: string;
  participantName: string = '';
  participantSurname: string = '';
  storeName: string = '';
  qrCodeDataUrl: string;

  exclusiveContent: any;
  yourOpinion: any;
  awards: any;

  constructor(
    private route: ActivatedRoute,
    private breadcrumbService: BreadcrumbService,
    private registerService: RegisterService,
    private translateService: TranslateService,
    private renderSafeHtmlService: RenderSafeHtmlService,
    private toastrService: ToastrService,
    private gtmService: GoogleTagManagerService
  ) {}

  ngOnInit() {
    this.route.parent?.params.subscribe((params) => {
      if (params["token"]) {
        this.token = params["token"];
      }
      if (params["tokenParticipant"]) {
        this.tokenParticipant = params["tokenParticipant"];
      }
    });

    this.getEvent();
  }

  changeBreadcrumbInRegister(
    title: string,
    preTitle: string,
    eventDetailButtons: boolean,
    token: string
  ) {
    this.breadcrumbService.changeBreadCrumbProps({
      title,
      preTitle,
      eventDetailButtons,
      token,
    });
  }

  getEvent() {
    console.log('qrCode getEvent')
    this.registerService
      .getEventForParticipants(this.token, this.tokenParticipant)
      .subscribe({
        next: (v) => {
          const data = v.data;
          this.mainObj = data.participants;
          const other_data = data.other_data;
          this.responseType = other_data.response_type;
          if (this.responseType === 2 && this.responseType !== null) {
            this.exclusiveContent = other_data.boxes.exclusive_contents;
          }
          if (this.responseType === 3) {
            this.exclusiveContent = other_data.boxes?.exclusive_contents ?? {};
            this.yourOpinion = other_data.boxes?.your_opinion ?? {};
            this.awards = other_data.boxes?.awards ?? {};
          }
          const qrcodeSvg = this.mainObj.ref_qr;
          this.qrCodeDataUrl = "data:image/svg+xml;base64," + btoa(qrcodeSvg);
          const event = this.mainObj.event;
          this.eventName = event?.title ?? '';

          this.eventDescription = event?.description ?? '';
          this.eventDates = event.dates;
          this.eventAddress = event.store?.address;
          this.eventType = event.type;
          this.participantName = this.mainObj.name;
          this.participantSurname = this.mainObj.surname;
          this.storeName = event.store?.name;
          let pretitle = this.translateService.instant("events.pre_title");
          this.changeBreadcrumbInRegister(this.eventName, pretitle, false, "");

          if (this.responseType === 1) {
            this.gtmService.pushEvent('subscribe_evento', {
              value: this.eventName
            });
          }
        },
        error: (e) => {
          this.anyErrors = true;
          console.error(e);
          let preTitle = this.translateService.instant("errors.title");
          let title = this.translateService.instant("errors.generic_error");

          if (e.status === 404) {
            preTitle = this.translateService.instant("events.title");
            title = this.translateService.instant("errors.event_not_found");
          }

          this.changeBreadcrumbInRegister(title, preTitle, false, "");
        },
      });
  }

  downloadQrCode(){

    this.registerService.getQrCode(this.token, this.tokenParticipant).subscribe({
      next: (response) => {
        const blob = new Blob([response], { type: 'image/png' });
        const url = window.URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = url;
        a.download = 'qr_code.png';
        document.body.appendChild(a);
        a.click();
        
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      },
      error: (error) => {
        console.error(`downloaQrCode error: ${error}`);
        const errorTranslate = this.translateService.instant('errors.access_error');
        this.toastrService.error(errorTranslate, error);
      }
    })
  }

  getHtml(value: string) {
    return this.renderSafeHtmlService.renderSafeHtml(this.translateService.instant(value), true)
  }

  handleClickExclusiveContent(url: string) {
    if (url) {
      window.open(url, '_blank');
      this.gtmService.pushEvent('cta_contenuti_evento', {
        value: this.eventName
      });
    }
  }

  handleClickYourOpinion(url: string) {
    if (url) {
      window.open(url, '_blank');
      this.gtmService.pushEvent('cta_sondaggio_evento', {
        value: this.eventName
      });
    }
  }

  handleClickAwards(url: string) {
    if (url) {
      window.open(url, '_blank');
      this.gtmService.pushEvent('cta_awards_evento', {
        value: this.eventName
      });
    }
  }


  
}
